var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"size":"lg","title":_vm.title},on:{"ok":_vm.emitDelete},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"variant":"primary"},on:{"click":ok}},[_vm._v("\n      Удалить\n    ")]),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":cancel}},[_vm._v("\n      Отмена\n    ")])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }